// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.MarkOneTimePaymentAsPaidOfflineWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { MarkOneTimePaymentAsPaidOfflineWebApiRequestDto } from '../..';

export const MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline_Path =
  '/api/web/v1/landlord/markOneTimePaymentAsPaidOffline';

/**
 * Mark a one-time payment or move-in costs group as received offline, on behalf of the landlord
 */
export const MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline = (
  postData: MarkOneTimePaymentAsPaidOfflineWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MarkOneTimePaymentAsPaidOfflineWebApiRequestDto, void>(
    {
      endpoint: MarkOneTimePaymentAsPaidOfflineWebApiHandler_markOneTimePaymentAsPaidOffline_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
